import { API_URL } from '../config/api';

export const loginUser = async (email: string, password: string) => {
  const response = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'بيانات الدخول غير صحيحة');
  }

  const data = await response.json();
  
  // حفظ التوكن وبيانات المستخدم في المتصفح
  localStorage.setItem('jwt_token', data.token);
  localStorage.setItem('user_data', JSON.stringify(data.user));
  
  return data;
};

export const logoutUser = () => {
  localStorage.removeItem('jwt_token');
  localStorage.removeItem('user_data');
  window.location.href = '/login';
};